/**
 * Harvest Mate - OEM Connection API
 *
 * Contact: servicedesk@clevvi.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * OEM provider key.
 */
export const Provider = {
    Deere: 'deere',
    Cnh: 'cnh'
} as const;
export type Provider = typeof Provider[keyof typeof Provider];

